module.exports = __webpack_public_path__ + "img/11-ABITO-TROPEA-SML-STAMPE-LINO2.626e3372.jpg";